import React, { FunctionComponent } from "react";
import "./style.scss";
import face_1_img from "../../asserts/svg/face_1.svg";
import face_2_img from "../../asserts/svg/face_2.svg";
import face_3_img from "../../asserts/svg/face_3.svg";
import face_4_img from "../../asserts/svg/face_4.svg";
import face_5_img from "../../asserts/svg/face_5.svg";
import face_6_img from "../../asserts/svg/face_6.svg";
import robot_point_img from "../../asserts/svg/robot_point_2.svg";
import arrow_img from "../../asserts/svg/arrow.svg";


const AboutBlock: FunctionComponent = () => {
    return <div id="about" className="AboutBlock">
        <div className="content">
            <h1>About</h1>
            <div className="tiles">
                <div className="tile">
                    <div className="images">
                        <img src={face_1_img} alt="face 1" />
                        <img src={face_2_img} alt="face 2" />
                        <img src={face_3_img} alt="face 3" />
                        <img src={face_4_img} alt="face 4" />
                    </div>
                    <div className="text">
                        We are a small team of passionate geeks like you who had suffered for decades from the tiresome time-tracking mess before we came up with Timinator that brought us peace and serenity so we could finally focus on the really important thing - CREATION.
                    </div>
                </div>

                <div className="tile">
                    <div className="images">
                        <img src={face_5_img} alt="face 5" />
                        <img src={arrow_img} alt="arrow" />
                        <img src={robot_point_img} alt="robot point" />
                        <img src={arrow_img} alt="arrow" />
                        <img src={face_6_img} alt="face 6" />
                    </div>
                    <div className="text">
                        We have no middleman or someone else in between. If you message us your text goes directly to the Timinator team. If you have a new feature request or you need help just text us and we will solve it as soon as possible.                    </div>
                    <div className="buttons">
                        <a href="mailto:hello@timinator.app">
                            <button className="mail">
                                <div className="image"/>
                                <div className="text">Mail us</div>
                            </button>
                        </a>

                        <a target="_blank" rel="noreferrer" href="https://t.me/timinator_admin">
                            <button className="tg">
                                <div className="image"/>
                                <div className="text">Telegram</div>
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default AboutBlock;